import React, { useState, useEffect } from 'react';
import config from 'react-global-configuration';
import { View, ViewFilters } from '@uncinc/react-drupal-core';
import className from 'classnames';
import qs from 'query-string';
import i18next from '../../../config/i18next';

import ApiAutocomplete from '../../../components/ApiAutocomplete';
import useQueryParams from '../../../helpers/useQueryString';
import { formatDate, getRelativeDate } from '../../../helpers/dates';
import {
  Container,
  Select,
  Button,
  Form,
} from '../../../components';

import Graph from './Graph';
import './style.scss';

const ViewFilterElementCustom = (props) => {
  const { filter, onChange, defaultValues, onReset } = props;
  const API_URL = config.get('API_URL');
  const options = [];
  let defaultValue = null;
  const operatorBetween = 'between';

  switch (filter.get('plugin_id')) {
    case 'datetime':
      options.push({ label: '- Geen voorkeur -' });

      if (filter.get('operator') === operatorBetween) {
        // This regex only allows numbers.
        const reg = new RegExp('^\\d+$');

        // In case the regex is true, that means a year has been input, so we have to rewrite the comparison.
        if (reg.test(filter.getIn(['value', 'min'])) === true) {
          for (let year = formatDate(getRelativeDate(new Date(), filter.getIn(['value', 'max'])), 'yyyy'); year >= formatDate(filter.getIn(['value', 'min']), 'yyyy'); year--) {
            options.push({ value: year, label: year });
          }
          // Else use the relative time.
        } else {
          for (let year = formatDate(getRelativeDate(new Date(), filter.getIn(['value', 'max'])), 'yyyy'); year >= formatDate(getRelativeDate(new Date(), filter.getIn(['value', 'min'])), 'yyyy'); year--) {
            options.push({ value: year, label: year });
          }
        }
      } else {
        for (let year = new Date().getFullYear(); year >= 2015; year--) {
          options.push({ value: year, label: year });
        }
      }

      if (defaultValues[filter.get('field')]) {
        defaultValue = { value: defaultValues[filter.get('field')].value, label: `${defaultValues[filter.get('field')].value}` };
      } else {
        defaultValue = options[0];
      }

      return (
        <div className="Form__element" key={filter.get('field')}>
          <label htmlFor={filter.get('field')}>{filter.getIn(['expose', 'label'])}</label>
          <Select
            name={filter.get('field')}
            id={filter.get('field')}
            handleChange={(option) => onChange(filter.get('field'), { value: option.value })}
            options={options}
            defaultValue={defaultValue}
            isSearchable={false}
          />
        </div>
      );

    case 'taxonomy_index_tid':
    case 'taxonomy_index_tid_depth':
      options.push({ label: '- Geen voorkeur -' });

      if (filter.get('options')) {
        filter.get('options').valueSeq().forEach((item) => {
          const value = item.get('value');
          const label = item.get('label');
          options.push({ value, label });

          if (item.get('children')) {
            item.get('children').map((subitem) => {
              const subvalue = subitem.get('value');
              const sublabel = subitem.get('label');
              options.push({ value: subvalue, label: <div><span className="indent" />{sublabel}</div> });
            });
          }
        });
      }

      if (defaultValues[filter.get('field')]) {
        const findOption = (items) => {
          return items.value === defaultValues[filter.get('field')];
        };

        defaultValue = options.find(findOption);
      } else {
        defaultValue = options[0];
      }

      return (
        <div className="Form__element" key={filter.get('field')}>
          <label htmlFor={filter.get('field')}>{filter.getIn(['expose', 'label'], '')}</label>
          <Select
            name={filter.get('field')}
            options={options}
            id={filter.get('field')}
            isSearchable={false}
            handleChange={(option) => {
              if (!option.value) {
                onReset(filter.get('field'));
              } else {
                onChange(filter.get('field'), option.value);
              }
            }}
            defaultValue={defaultValue}
          />
        </div>
      );

    case 'string':
      if (defaultValues[filter.get('field')]) {
        defaultValue = defaultValues[filter.get('field')];
      }

      return (
        <div className="Form__element" key={filter.get('field')}>
          <label htmlFor={filter.get('field')}>{filter.getIn(['expose', 'label'])}</label>
          <ApiAutocomplete
            name={filter.get('field')}
            id={filter.get('field')}
            endpoint={`${API_URL}/api/autocomplete/cities`}
            placeholder="Zoek op plaatsnaam"
            defaultValue={defaultValue}
            onSelectItem={(item) => {
              onChange(filter.get('field'), item.name);
            }}
            renderItem={(item, active) => {
              const classes = className({
                active: active,
              });
              return (
                <div className={classes}>
                  {item.name}
                </div>
              );
            }}
          />
        </div>
      );

    default:
      return (
        <div>
          Filter Element: {filter.get('plugin_id')}
        </div>
      );
  }
};

const getFiltersFromParams = (params) => {
  const newFilters = {};
  if (params.year) {
    newFilters.field_date_value = ({
      value: `${params.year}`,
      min: `${params.year}-01-01`,
      max: `${params.year}-12-31`,
    });
  }
  if (params.term_node_tid_depth) {
    newFilters.term_node_tid_depth = params.term_node_tid_depth;
  }
  if (params.locality) {
    newFilters.field_address_locality = params.locality;
  }

  return newFilters;
};

const Awards = () => {
  const API_URL = config.get('API_URL');
  const [params, setParams] = useQueryParams();
  const [filters, setFilters] = useState(getFiltersFromParams(params));
  const [appliedFilters, setAppliedFilters] = useState(getFiltersFromParams(params));
  const [results, setResults] = useState();
  const [downloadUrl, setDownloadUrl] = useState();

  const resultClasses = className('View-Awards__results', {
    'View-Awards__results--no-result': results === 0,
  });

  useEffect(() => {
    const newFilters = getFiltersFromParams(params);

    if (!(Object.keys(newFilters).length === 0 && newFilters.constructor === Object)) {
      setAppliedFilters(newFilters);
    }
  }, [params]);


  const resetFilter = (field) => {
    const newFilters = { ...appliedFilters };
    delete newFilters[field];
    setFilters(newFilters);
  };

  const submitFilters = () => {
    const newParams = {};
    if (filters.field_date_value) {
      newParams.year = filters.field_date_value.value;
    } else {
      newParams.year = null;
    }
    if (filters.field_address_locality !== null) {
      newParams.locality = filters.field_address_locality;
    } else {
      newParams.locality = null;
    }
    if (filters.term_node_tid_depth) {
      newParams.term_node_tid_depth = [filters.term_node_tid_depth];
    } else {
      newParams.term_node_tid_depth = null;
    }
    setAppliedFilters(filters);
    setParams(newParams);
  };

  const updateFilter = (field, value) => {
    const newFilters = { ...filters };
    if (value === undefined) {
      delete newFilters[field];
    } else if (field === 'field_date_value') {
      if (value.value === undefined) {
        delete newFilters[field];
      } else {
        const year = value.value;
        newFilters.field_date_value = { value: year, min: `${year}-01-01`, max: `${year}-12-31` };
      }
    } else {
      newFilters[field] = value;
    }
    setFilters(newFilters);
  };

  useEffect(() => {
    const queryParams = qs.stringify({
      year: params.year ? params.year : null,
      locality: params.locality ? params.locality : null,
      area: params.term_node_tid_depth ? params.term_node_tid_depth : null,
    }, {
      skipNull: true,
    });

    setDownloadUrl(`${API_URL}/api/awards/download?_format=xlsx&${queryParams}`)
  }, [params]);

  return (
    <div className="View-Awards">
      <Container>
        <div className="row">
          <div className="col-12 col-sm-4">
            <div className="View-Awards__filters">
              <h2>Filters</h2>
              <Form onSubmit={(e) => { e.preventDefault(); submitFilters(); }}>
                <ViewFilters
                  viewId="awards"
                  display="default"
                  onFilterUpdate={(field, value) => updateFilter(field, value)}
                  onResetFilter={(field) => { resetFilter(field); }}
                  onRender={(props) => {
                    return <ViewFilterElementCustom {...props} defaultValues={appliedFilters} />;
                  }}
                />
                <button type="submit">Pas filters toe</button>
              </Form>
            </div>

            <div className="View-Awards__download mt-6 pt-6">
              <h2>{i18next.t('awards.download.title')}</h2>
              <p>{i18next.t('awards.download.description')}</p>
              <div className="View-Awards__map_button">
                {downloadUrl && (
                  <Button
                    secondary
                    withIcon
                    buttonIcon
                    href={downloadUrl}
                  >
                    {i18next.t('awards.download.button')}
                  </Button>
                )}
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-8">
            <div className="View-Awards__map_header">
              {results === 0 && <div className="View-Awards__map_header--no-result">{i18next.t('awards_no_result')}</div>}
              <Button
                secondary
                withIcon
                icon="marker"
                className="moving-arrow"
                variant="icon-variant-2"
                href="/landkaart?mapType=award&viewportNortheastLat=53.5104033474&viewportNortheastLng=7.09205325687&viewportSouthwestLat=50.803721015&viewportSouthwestLng=3.31497114423"
              >
                {i18next.t('to_the_map')}
              </Button>
            </div>
            <div className={resultClasses}>
              <Graph filters={appliedFilters} />
              <View id="awards" display="block_1" filters={appliedFilters} setResults={setResults} />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Awards;
